const data = {
  id: 1,
  title: 'Write the past simple and past participle form of these following words.',
  subTitle: 'Viết dạng quá khứ và dạng phân từ hai của động từ.',
  question: '',
  audio: '',
  answers: [
    { id: 1, answer: 'Go', answersList: ['went', 'gone'], isCorrect: true, audio: '' },
    { id: 2, answer: 'Get', answersList: ['got', 'got'], isCorrect: true, audio: '' },
  ]
}


export default data;